import React, { Component, Fragment } from "react";
import { API, Storage, Auth } from "aws-amplify";
import AuthorWidget from "./AuthorWidget";
import CarouselWidget from "./CarouselWidget";
import BlogContent from "./BlogContent";
import CommentsWidget from "./CommentsWidget";

export default class BlogWidget extends Component {

      constructor(props){
          super(props);

          if(props.blog){
            this.state= {
              errorMsg: "",
              blogTitle: this.props.blog.title,
              blogContent: this.props.blog.content,
              blogAuthor: this.props.blog.author,
              blogId: this.props.blog.blogId,
              blogCreateTime: this.props.blog.createdAt,
              isVideo: this.props.blog.isVideo,
              attachments: [],
              attachmentUrls: [],
              accordionState: "Show More",
              isDeleting: false
            }
            if(this.props.blog.attachment && this.props.blog.attachment.length > 0){
              this.state.attachments = this.props.blog.attachment.split(",");
            }


          }else{
            this.state = {
                //empty state
            }
          }
     }

      async componentDidMount(){

        if(!this.props.isAuthenticated){
          return;
        }

        try{

          var attachmentUrls = [];
          for(var i = 0 ; i < this.state.attachments.length; i++){
              attachmentUrls[i] = await Storage.get(this.state.attachments[i]);
          }

          if(this.props.blog.profilePic && this.props.blog.profilePic.length > 0){
            var blogAuthorProfilePic = await Storage.get(this.props.blog.profilePic);
            this.setState({authorProfilePic: blogAuthorProfilePic});
          }


          if(attachmentUrls.length > 0){
            this.setState({attachmentUrls: attachmentUrls});
          }

          var caseOfTheMonth = await this.props.getCaseOfTheMonth();
          this.setState({userProfile: this.props.userProfile,
              caseOfTheMonth: caseOfTheMonth
          });



        }catch(e){
          if(e.response.data.error != "Case of the month not set."){
            this.setState({errorMsg: e.message});
          }

        }

      }

      handleCollapseToggle = event => {
        event.preventDefault();
        if(this.state.accordionState === "Show More"){
          this.setState({accordionState: "Show Less"});
        }else{
          this.setState({accordionState: "Show More"});
        }
      }

      deleteBlog = async event => {
          try{
            this.setState({isDeleting: true});
            var retValue = await API.del("retnetindia", "/blogs/"+this.props.blog.blogId);

            window.location.reload();

          }catch(e){
            this.setState({errorMsg: e.message});
          }

      }

      getErrorElement(){
         return this.state.errorMsg && this.state.errorMsg.length > 0
                                 ? <div className="alert alert-danger" role="alert">
                                     {this.state.errorMsg}
                                   </div>
                                 : "";
      }

      renderModalDialog(blogId){
        return(
          <div className="modal fade" id={"delete-"+blogId} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" >Delete Blog Confirmation</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                       You cannot get it back once deleted. Do you want to delete the blog?
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-primary" data-dismiss="modal">Cancel</button>
                      <button type="button" className="btn btn-danger" onClick={this.deleteBlog} data-dismiss="modal">Delete</button>
                    </div>
                  </div>
                </div>
          </div>
        );
      }

      makeCaseOfTheMonth = async event =>{

        try{
            var response = await API.put("retnetindia", "/com/"+this.props.blog.blogId);
            // this.props.history.push("/");

        }catch(e){
           this.setState({errorMsg: e.message});
        }

      }

      editBlog = event => {
        this.props.history.push({
            pathname: '/blogs/new',

            state: { blog: this.props.blog }
          })
      }

      renderDeleteIcon(){
        if(!this.props.blog || !this.props.userProfile ){
          return(
            <span></span>
          );
        }

        if(this.state.isDeleting){
          return(
            <span className="pull-right">
               Deleting the blog
               <i className="fa fa-spinner fa-spin"></i>
            </span>
          );

        }

        if(this.props.blog.userId === this.props.userProfile.userId || (this.props.userProfile.role && this.props.userProfile.role === "su")){
          return(
            <Fragment>
                <i  className="fa fa-trash pull-right"
                          aria-hidden="true"
                      data-toggle="modal" data-target={"#delete-"+this.props.blog.blogId}></i>
                <i  className="fa fa-edit pull-right"
                        aria-hidden="true"
                        id={"edit-"+this.props.blog.blogId}
                        onClick={this.editBlog}></i>
            </Fragment>

          );
        }
        return(
          <span></span>
        );
      }

      renderCaseOfTheMonthButton = () =>{
        if(!this.props.blog || !this.props.userProfile ){
          return(
            <span></span>
          );
        }

        if(this.props.userProfile.role && this.props.userProfile.role === "su"){
              if(!this.state.caseOfTheMonth || this.state.caseOfTheMonth.blogId !== this.props.blog.blogId) {
                return(
                  <Fragment>
                  <br />
                  <div className="radio">
                     <input type="radio"
                            name="caseofthemonth"
                            value={this.props.blog.blogId}
                            onClick={this.makeCaseOfTheMonth}
                             />
                       <label>
                           Case Of The Month
                      </label>
                  </div>

                  </Fragment>
                );

              }else{
                return(
                  <Fragment>
                  <br />
                  <div className="radio">
                     <input type="radio"
                            name="caseofthemonth"
                            value={this.props.blog.blogId}
                            onClick={this.makeCaseOfTheMonth}
                            checked  />
                       <label>
                           Case Of The Month
                      </label>
                  </div>

                  </Fragment>
                );

              }

        }

      }

      render() {
          return(
            <div>

                <div id={"accordion-"+this.props.blog.blogId} className="blog-widget">
                      <div className="card">

                        <div className="card-header retnet-blog-header" >
                          <h5 className="mb-0"
                                data-toggle="collapse"
                                data-target={"#collapse-"+this.props.blog.blogId}
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                onClick={this.handleCollapseToggle}>
                              {this.getErrorElement()}
                              <AuthorWidget blog={this.state}/>
                          </h5>

                          {this.renderCaseOfTheMonthButton()}
                          {this.renderDeleteIcon()}

                        </div>

                        <div id={"collapse-"+this.props.blog.blogId}
                          className="collapse" aria-labelledby="headingOne"
                          data-parent={"#accordion-"+this.props.blog.blogId}>
                            <div className="card-body">
                                <CarouselWidget  blog={this.props.blog} blogimages={this.state.attachmentUrls}/>
                                <BlogContent blogContent={this.state.blogContent}/>
                                <hr />
                                <CommentsWidget blog={this.props.blog}
                                              userProfile={this.props.userProfile}/>
                            </div>
                        </div>
                      </div>
                </div>
                <br />
                {this.renderModalDialog(this.props.blog.blogId)}
            </div>

          );
      }
}



// WEBPACK FOOTER //
// ./src/containers/BlogWidget.js